import { GapPoItemDetails } from "./gap-po-item-details";

export class GapPoDetails {
    poNumber: string;
    buyerName: string;
    transMode: string;
    currency: string;
    buyerAddress: string;
    deliveryAddress: string;
    deliveryDate: string;
    exFactoryDate: string;
    incoterm:string;
    totalQuantity:string;
  
    GappoItemDetails: GapPoItemDetails[]
}